<script>
import { BCol } from "bootstrap-vue";

export default {
  extends: BCol
};
</script>